import './index.scss';
import ModalManager from 'utils/modal_manager';

function openModal() {
  ModalManager.open('#js-practice-test-cannot-create-modal');
}

$('.js-practice-test-cannot-create').on('click', () => openModal());

if (window.location.hash === '#criar-simulado') {
  setTimeout(() => openModal(), 500);
}
